import { get, post } from './client';
import type {
  NotionAiTasksListResponse,
  NotionAiTasksSettingsResponse,
  NotionAiTasksStatusResponse,
  NotionAiTasksSyncResponse,
  NotionAiTasksTestResponse,
} from '@/types/notion-ai-tasks';

export interface NotionAiTasksFilters {
  status?: string;
  priority?: string;
  owner?: string;
  department?: string;
  include_archived?: boolean;
  limit?: number;
  offset?: number;
}

function buildQuery(filters?: NotionAiTasksFilters): string {
  const params = new URLSearchParams();
  if (filters?.status) params.set('status', filters.status);
  if (filters?.priority) params.set('priority', filters.priority);
  if (filters?.owner) params.set('owner', filters.owner);
  if (filters?.department) params.set('department', filters.department);
  if (filters?.include_archived !== undefined) params.set('include_archived', String(filters.include_archived));
  if (filters?.limit !== undefined) params.set('limit', String(filters.limit));
  if (filters?.offset !== undefined) params.set('offset', String(filters.offset));
  const query = params.toString();
  return query ? `?${query}` : '';
}

export async function saveNotionAiTasksSettings(
  teamId: string,
  data: { database_id?: string; api_token?: string; clear?: boolean }
): Promise<NotionAiTasksSettingsResponse> {
  return post<NotionAiTasksSettingsResponse>(`/api/teams/${teamId}/notion-ai-tasks/settings`, data);
}

export async function testNotionAiTasks(teamId: string): Promise<NotionAiTasksTestResponse> {
  return get<NotionAiTasksTestResponse>(`/api/teams/${teamId}/notion-ai-tasks/test`);
}

export async function syncNotionAiTasks(teamId: string): Promise<NotionAiTasksSyncResponse> {
  return post<NotionAiTasksSyncResponse>(`/api/teams/${teamId}/notion-ai-tasks/sync`, {});
}

export async function getNotionAiTasksStatus(teamId: string): Promise<NotionAiTasksStatusResponse> {
  return get<NotionAiTasksStatusResponse>(`/api/teams/${teamId}/notion-ai-tasks/status`);
}

export async function getNotionAiTasks(
  teamId: string,
  filters?: NotionAiTasksFilters
): Promise<NotionAiTasksListResponse> {
  return get<NotionAiTasksListResponse>(`/api/teams/${teamId}/notion-ai-tasks${buildQuery(filters)}`);
}
